module.exports = __webpack_public_path__ + "static/img/logo.43abe9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/home/logo.png
// module id = jO1D
// module chunks = 51